/* eslint-disable no-unused-vars */
import axios from 'axios';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import localStorage from '../../../utils/localStorage';
import { API_DASHBOARD, API_FILE, API_HIERARCHYMODULE, WARNINGLIMITS } from '../../../commons/api';

dayjs.extend(utc);
dayjs.extend(timezone);

export async function getChartDataWithoutSelection(props) {
  let { graphprops, abortController, dropdownSelection, DeviceCode, TimeZone } = props;
  let SiteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');
  var Authorization = 'Bearer ' + token;
  try {
    let response = await fetch(`${API_DASHBOARD.GetDashboard}?SiteId=${SiteId}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization
      },
      body: JSON.stringify({
        Name: graphprops.dashboardName,
        PanelName: graphprops.title,
        Id: graphprops.id,
        SiteId,
        TimeZone,
        ...dropdownSelection,
        ...(DeviceCode ? { DeviceCode } : {})
      }),
      signal: abortController.signal
    });
    // if (!response.ok) {
    //   throw new Error(`HTTP error! Status: ${response.status}`);
    // }
    const json = await response.json();
    return json;
  } catch (error) {
    if (error.name === 'AbortError') {
      return null;
    }
    console.error('Error in getChartDataWithoutSelection:', error);
    throw error;
  }
}

export async function getChartDataWithSelection(props) {
  let {
    graphprops,
    DeviceCode,
    selectionDate,
    selectionMonth,
    selectionWeek,
    shift,
    selectionDateRange,
    dayMonthYear,
    dropdownSelection,
    AssetCode,
    extraKeys,
    currentTimeZone,
    abortController
  } = props;
  console.log(props,"curururur",currentTimeZone);
  let SiteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');
  let { dashboardName, title, type, id } = graphprops;
  let newdashboardPayload = {};
  let newDatePayload = {};
  let newDateRangePayload = {};
  let newMonthPayload = {};
  let newShiftPayload = {};
  let newWeekPayload = {};
  let newdayMonthYearPayload = {};
  let newmultiDropdownPayload = {};
  let treePayload = {};
  let TimeBucket =
    graphprops && graphprops.GraphLevelTimeBucket
      ? graphprops.GraphLevelTimeBucket
      : graphprops.TimeBucket;

  let payload = {
    Name: dashboardName,
    PanelName: title,
    Id: id,
    TimeBucket,
    TimeZone : currentTimeZone,
    ...(extraKeys ? extraKeys : {}),
    SiteId
  };

  let selectionPoint = '0';
  if (graphprops.DashboardLevelSelection !== 'none') {
    selectionPoint =
      graphprops &&
        graphprops.DashboardLevelSelectionPoint &&
        graphprops.DashboardLevelSelectionPoint === 'PreviousDay'
        ? '1'
        : '0';
  } else if (graphprops.GraphLevelSelection !== 'none') {
    selectionPoint =
      graphprops &&
        graphprops.GraphLevelSelectionPoint &&
        graphprops.GraphLevelSelectionPoint === 'PreviousDay'
        ? '1'
        : '0';
  }

  // DatePicker selection
  if (
    graphprops.DashboardLevelSelection === 'datePicker' ||
    graphprops.GraphLevelSelection === 'datePicker'
  ) {
    let startFormat = 'YYYY-MM-DD 00:00:00';
    let endFormat = 'YYYY-MM-DD 23:59:59';

    if (!dayjs(selectionDate).isValid()) {
      console.warn('Warning: Invalid selectionDate:', selectionDate);
    } else {
      let start = dayjs(selectionDate).format(startFormat);
      let end = dayjs(selectionDate).format(endFormat);

      if (type !== 'summary') {
        newDatePayload = {
          StartDate: dayjs.tz(start, currentTimeZone).utc().format('YYYY-MM-DD HH:mm:ss'),
          EndDate: dayjs.tz(end, currentTimeZone).utc().format('YYYY-MM-DD HH:mm:ss')
        };
      } else {
        newDatePayload = {
          StartDate: dayjs(start).format('YYYY-MM-DD HH:mm:ss'),
          EndDate: dayjs(end).format('YYYY-MM-DD HH:mm:ss')
        };
      }
    }
  }
  if (
    graphprops.DashboardLevelSelection === 'monthPicker' ||
    graphprops.GraphLevelSelection === 'monthPicker'
  ) {
    let currentMonth = dayjs().format('MM');
    let currentYear = dayjs().format('YYYY');

    const [year, month] = selectionMonth.split('-').map(Number);
    const firstDayOfMonth = `${year}-${String(month).padStart(2, '0')}-01 00:00:00`;
    const startDate = dayjs.tz(firstDayOfMonth, currentTimeZone).utc().format('YYYY-MM-DD HH:mm:ss');
    let endDate;
    if (type !== 'summary') {
      endDate = dayjs().utc().format('YYYY-MM-DD HH:mm:ss');
    } else {
      if (String(month).padStart(2, '0') === currentMonth && String(year) === currentYear) {
        endDate = dayjs()
          .tz(currentTimeZone)
          .subtract(selectionPoint, 'day')
          .format('YYYY-MM-DD HH:mm:ss');
      } else {
        endDate = dayjs
          .tz([year, month - 1], currentTimeZone)
          .endOf('month')
          .subtract(selectionPoint, 'day')
          .format('YYYY-MM-DD HH:mm:ss');
      }
    }

    newMonthPayload = {
      StartDate: startDate,
      EndDate: endDate,
    };


  }

  // WeekPicker selection
  if (
    graphprops.DashboardLevelSelection === 'weakPicker' ||
    graphprops.GraphLevelSelection === 'weakPicker'
  ) {
    if (!selectionWeek || typeof selectionWeek !== 'object' || !dayjs(selectionWeek).isValid()) {
      console.warn('Warning: Invalid selectionWeek:', selectionWeek);
    } else {
      let currentWeek = dayjs().startOf('week');
      if (type !== 'summary') {
        newWeekPayload = {
          StartDate: dayjs.tz(selectionWeek, currentTimeZone).startOf('week').utc().format('YYYY-MM-DD HH:mm:ss'),
          EndDate: selectionWeek.isSame(currentWeek)
            ? dayjs.tz(currentTimeZone).subtract(selectionPoint, 'day').utc().format('YYYY-MM-DD HH:mm:ss')
            : dayjs.tz(selectionWeek, currentTimeZone).endOf('week').subtract(selectionPoint, 'day').utc().format('YYYY-MM-DD HH:mm:ss')
        };
      } else {
        newWeekPayload = {
          StartDate: dayjs(selectionWeek).startOf('week').format('YYYY-MM-DD HH:mm:ss'),
          EndDate: selectionWeek.isSame(currentWeek)
            ? dayjs.tz(currentTimeZone).format('YYYY-MM-DD HH:mm:ss')
            : dayjs.tz(selectionWeek, currentTimeZone).endOf('week').subtract(selectionPoint, 'day').format('YYYY-MM-DD HH:mm:ss')
        };
      }
    }
  }

  // DateRangePicker selection
  if (
    graphprops.DashboardLevelSelection === 'dateRangePicker' ||
    graphprops.GraphLevelSelection === 'dateRangePicker'
  ) {
    if (!selectionDateRange || !selectionDateRange.startDate || !selectionDateRange.endDate) {
      console.warn('Warning: Invalid selectionDateRange:', selectionDateRange);
    } else {
      if (type !== 'summary') {
        newDateRangePayload = {
          StartDate: dayjs(selectionDateRange.startDate).utc().format('YYYY-MM-DD HH:mm:ss'),
          EndDate: dayjs(selectionDateRange.endDate).utc().format('YYYY-MM-DD HH:mm:ss')
        };
      } else {
        newDateRangePayload = {
          StartDate: dayjs(selectionDateRange.startDate).format('YYYY-MM-DD HH:mm:ss'),
          EndDate: dayjs(selectionDateRange.endDate).format('YYYY-MM-DD HH:mm:ss')
        };
      }
    }
  }

  // DayMonthYearPicker selection
  if (
    graphprops.DashboardLevelSelection === 'dateMonthYearPicker' ||
    graphprops.GraphLevelSelection === 'dateMonthYearPicker'
  ) {
    if (!dayMonthYear || !dayMonthYear.StartDate || !dayMonthYear.EndDate) {
      console.warn('Warning: Invalid dayMonthYear:', dayMonthYear);
    } else if (!dayjs(dayMonthYear.StartDate).isValid() || !dayjs(dayMonthYear.EndDate).isValid()) {
      console.warn('Warning: Invalid dayMonthYear dates:', dayMonthYear.StartDate, dayMonthYear.EndDate);
    } else {
      if (type !== 'summary') {
        newdayMonthYearPayload = {
          ...dayMonthYear,
          StartDate: dayjs.tz(dayMonthYear.StartDate, currentTimeZone).utc().format('YYYY-MM-DD HH:mm:ss'),
          EndDate: dayjs.tz(dayMonthYear.EndDate, currentTimeZone).utc().format('YYYY-MM-DD HH:mm:ss')
        };
      } else {
        newdayMonthYearPayload = {
          ...dayMonthYear,
          StartDate: dayjs.tz(dayMonthYear.StartDate, currentTimeZone).format('YYYY-MM-DD HH:mm:ss'),
          EndDate: dayjs.tz(dayMonthYear.EndDate, currentTimeZone).format('YYYY-MM-DD 23:59:59')
        };
      }
    }
  }

  // ShiftPicker selection
  if (
    graphprops.DashboardLevelSelection === 'shiftPicker' ||
    graphprops.GraphLevelSelection === 'shiftPicker'
  ) {
    newShiftPayload = {
      Shift: shift
    };
  }

  // Tree payload
  if (graphprops.hierarchyViewType === "Tree Drawer") {
    treePayload = {
      DeviceCode
    };
  }
  // DashboardType dynamic check
  if (graphprops.hierarchyViewType === 'Tree Select' || DeviceCode || graphprops.GraphLevelSelection === "deviceSelection") {
    newdashboardPayload = {
      DeviceCode
    };
  }

  // Multi or hierarchy dashboard dropdown selection
  if (
    dropdownSelection &&
    (graphprops.dashboardType === 'multi' || graphprops.dashboardType === 'hierarchy')
  ) {
    newmultiDropdownPayload = dropdownSelection;
  }

  // Merge all payload parts
  payload = {
    ...payload,
    ...newdashboardPayload,
    ...newDatePayload,
    ...newMonthPayload,
    ...newWeekPayload,
    ...newShiftPayload,
    ...newDateRangePayload,
    ...newdayMonthYearPayload,
    ...newmultiDropdownPayload,
    ...treePayload
  };

  var Authorization = 'Bearer ' + token;
  try {
    let response = await fetch(`${API_DASHBOARD.GetDashboard}?SiteId=${SiteId}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: Authorization
      },
      body: JSON.stringify(payload),
      signal: abortController.signal
    });
    if (!response.ok) {
      // Try to parse error details from the response body
      let errorDetails;
      try {
        errorDetails = await response.json();
      } catch {
        errorDetails = { message: 'No error details provided' };
      }
      console.error('API Error:', {
        status: response.status,
        statusText: response.statusText,
        errorDetails
      });
      // Return a consistent error object
      return {
        success: false,
        status: response.status,
        message: errorDetails.message || response.statusText,
        errorDetails
      };
    }
    const json = await response.json();
    return json;
  } catch (error) {
    if (error.name === 'AbortError') {
      return null;
    }
    throw error;
  }
}


export async function getMaximoHierarchyData(abortController) {
  let siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');
  var Authorization = 'Bearer ' + token;
  try {
    let response = await fetch(`${API_HIERARCHYMODULE.GetMaximoHierarchy}?SiteId=${siteId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: Authorization
      },
      signal: abortController.signal
    });
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const json = await response.json();
    return json;
  } catch (error) {
    if (error.name === 'AbortError') {
      return null;
    }
    console.error('Error in getMaximoHierarchyData:', error);
    throw error;
  }
}

export function _getReportNametoDownload(excelData) {
  let payload = {
    date: dayjs().format('YYYY-MM-DD'),
    time: dayjs().format('HH:mm:ss'),
    data: excelData || []
  };

  let siteId = localStorage.get('currentSite');
  let accessToken = localStorage.get('accessToken');
  let options = {
    method: 'POST',
    url: `${API_FILE.GenerateExcel}?SiteId=${siteId}`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`
    },
    data: JSON.stringify(payload)
  };
  return axios(options)
    .then(({ data }) => {
      return data;
    })
    .catch(() => {
      return '';
    });
}

export async function getChartWarningSelection(props) {
  let {
    graphprops,
    DeviceCode,
    selectionDate,
    selectionMonth,
    selectionWeek,
    shift,
    selectionDateRange,
    dayMonthYear,
    abortController,
    dropdownSelection,
    dashboardPayload,
    AssetCode,
    selectionDateLive,
    timeZone
  } = props;
  let siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');

  let newdashboardPayload = {};
  let newDatePayload = {};
  let newDateRangePayload = {};
  let newMonthPayload = {};
  let newShiftPayload = {};
  let newWeekPayload = {};
  let newdayMonthYearPayload = {};
  let newmultiDropdownPayload = {};
  let treePayload = {};
  let payload = {
    Name: graphprops && graphprops.dashboardName,
    PanelName: graphprops && graphprops.title,
    Id: graphprops && graphprops.id,
    type: (graphprops && graphprops.type) || 'historic',
    timeZone,
    date: timeZone
      ? dayjs.tz(dayjs().format('YYYY-MM-DD HH:mm:ss'), timeZone).utc().format('YYYY-MM-DD HH:mm:ss')
      : dayjs().format('YYYY-MM-DD HH:mm'),
    dashboardType: 'static',
    siteId,
    startDate: timeZone
      ? dayjs.tz(dayjs().subtract(1, 'hour').format('YYYY-MM-DD HH:mm:ss'), timeZone).utc().format('YYYY-MM-DD HH:mm:ss')
      : dayjs().subtract(1, 'hour').utc().format('YYYY-MM-DD HH:mm:ss'),
    endDate: timeZone
      ? dayjs.tz(dayjs().format('YYYY-MM-DD HH:mm:ss'), timeZone).utc().format('YYYY-MM-DD HH:mm:ss')
      : dayjs().utc().format('YYYY-MM-DD HH:mm:ss'),

    timeBucket: '1h'
  };

  if (graphprops.dashboardType === 'dynamic' || DeviceCode) {
    newdashboardPayload = {
      dashboardType: 'dynamic',
      DeviceCode
    };
  }

  if (
    dropdownSelection &&
    (graphprops.dashboardType === 'multi' || graphprops.dashboardType === 'hierarchy')
  ) {
    newmultiDropdownPayload = dropdownSelection;
  }
  if (graphprops.dateExists === 'true' || graphprops.selection === 'datePicker') {
    newDatePayload = {
      dateExists: true,
      date: dayjs.tz(selectionDate, timeZone).utc().format('YYYY-MM-DD HH:mm:ss')
    };
  }
  if (graphprops.dateExists === 'true') {
    newDatePayload = {
      dateExists: true,
      date: dayjs.tz(selectionDateLive, timeZone).utc().format('YYYY-MM-DD HH:mm:ss')
    };
  }

  if (graphprops.monthExists === 'true') {
    let monthYear = selectionMonth.split('-');
    let currentYear = dayjs().format('YYYY-MM');
    let selectedYear = monthYear[0];
    let selectedmonth = monthYear[1];
    newMonthPayload = {
      monthExists: true,
      timeBucket: '1d',
      DeviceCode,
      selectionType: 'month',
      startDate: dayjs
        .tz([monthYear[0], monthYear[1]], timeZone)
        .startOf('month')
        .subtract(1, 'month')
        .utc()
        .format('YYYY-MM-DD HH:mm:ss'),
      endDate:
        selectionMonth === currentYear
          ? dayjs().subtract(1, 'day').utc().format('YYYY-MM-DD HH:mm:ss')
          : dayjs
            .tz([selectedYear, selectedmonth - 1], timeZone)
            .endOf('month')
            .utc()
            .format('YYYY-MM-DD HH:mm:ss')
    };
  }

  if (graphprops.weekExists === 'true') {
    let currentWeek = dayjs().startOf('week');
    newWeekPayload = {
      weekExists: true,
      startDate: dayjs
        .tz(selectionWeek, timeZone)
        .startOf('week')
        .utc()
        .format('YYYY-MM-DD HH:mm:ss'),
      endDate: selectionWeek.isSame(currentWeek)
        ? dayjs().subtract(1, 'day').format('YYYY-MM-DD HH:mm:ss')
        : dayjs
          .tz(selectionWeek, timeZone)
          .endOf('week')
          .utc()
          .format('YYYY-MM-DD HH:mm:ss')
    };
  }

  if (graphprops.shiftExists === 'true') {
    newShiftPayload = {
      shiftExists: true,
      shift
    };
  }

  if (graphprops.dateRangeExists === 'true' || graphprops.selection === 'dateRangePicker') {
    newDateRangePayload = {
      dateRangeExists: true,
      ...selectionDateRange,
      startDate: dayjs
        .tz(selectionDateRange && selectionDateRange.startDate ? selectionDateRange.startDate : '', timeZone)
        .utc()
        .format('YYYY-MM-DD HH:mm:ss'),
      endDate: dayjs
        .tz(selectionDateRange && selectionDateRange.endDate ? selectionDateRange.endDate : '', timeZone)
        .utc()
        .format('YYYY-MM-DD HH:mm:ss')
    };
  }

  if (graphprops.dayMonthYearExists === 'true' || graphprops.selection === 'dateMonthYearPicker') {
    if (graphprops.type === 'summary') {
      newdayMonthYearPayload = {
        dayMonthYearExists: true,
        ...dayMonthYear,
        date: dayjs().format('YYYY-MM-DD HH:mm:ss'),
        startDate: dayjs(dayMonthYear && dayMonthYear.startDate).format('YYYY-MM-DD HH:mm:ss'),
        endDate: dayjs(dayMonthYear && dayMonthYear.endDate).format('YYYY-MM-DD HH:mm:ss'),
        timeZone
      };
    } else {
      newdayMonthYearPayload = {
        dayMonthYearExists: true,
        ...dayMonthYear,
        startDate: dayjs
          .tz(dayMonthYear && dayMonthYear.startDate ? dayMonthYear.startDate : '', timeZone)
          .utc()
          .format('YYYY-MM-DD HH:mm:ss'),
        endDate: dayjs
          .tz(dayMonthYear && dayMonthYear.endDate ? dayMonthYear.endDate : '', timeZone)
          .utc()
          .format('YYYY-MM-DD HH:mm:ss')
      };
    }
  }

  if (graphprops.treeExists === 'true' || graphprops.selection === 'dateMonthYearPicker') {
    treePayload = {
      AssetCode: AssetCode
    };
  }

  payload = {
    ...payload,
    ...newdashboardPayload,
    ...newDatePayload,
    ...newMonthPayload,
    ...newWeekPayload,
    ...newShiftPayload,
    ...newDateRangePayload,
    ...newdayMonthYearPayload,
    ...newmultiDropdownPayload,
    ...treePayload
  };

  var Authorization = 'Bearer ' + token;
  try {
    let response = await fetch(`${WARNINGLIMITS.GetWarningData}?SiteId=${siteId}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: Authorization
      },
      body: JSON.stringify(payload),
      signal: abortController.signal
    });
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const json = await response.json();
    return json;
  } catch (error) {
    if (error.name === 'AbortError') {
      return null;
    }
    console.error('Error in getChartWarningSelection:', error);
    throw error;
  }
}


